$(function () {
    "use strict";

    $(document).on('ready', function () {
        var $closeBanner = $('.add-product-banner__close');


        $closeBanner.on('click', function() {
            var url = $(this).data('url');
            $.ajax({
                url: url,
                type: 'POST'
            })
                .done(function (data) {
                    $closeBanner.closest('.add-product-banner').hide();
                })
                .fail(function () {
                    Toasts.pushToast(data.error || data.errors[0] || 'Что-то пошло не так, попробуйте позже', 'fail');
                })
            ;
        });
    });
});
